import React from 'react'
import TopBar from '../../components/TopBar'

const Dashboard = () => {
  return (
    <div>
      <TopBar/>
    </div>
  )
}

export default Dashboard
